import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import PlayButton from '../../../Core/PlayButton';
import VideoOverlay from '../../../Core/VideoOverlay';

import { Wrapper, StyledVideo, TitleWrapper } from './styles';

function VideoPlayer({ data }) {
  if (!data) return null;
  const {
    titleHtml, subtitleHtml, video, image, imageSharp, focusTextColour,
  } = data;
  const [playing, setPlaying] = useState(false);
  return (
    <Wrapper id="video-player">
      {!playing && (
        <VideoOverlay
          thumbnail={imageSharp ? imageSharp.publicURL : image.url}
          onClick={() => setPlaying(true)}
        >
          <TitleWrapper focusTextColour={focusTextColour}>
            {ReactHtmlParser(titleHtml)}
            {ReactHtmlParser(subtitleHtml)}
          </TitleWrapper>
          <PlayButton onClick={() => setPlaying(true)} />
        </VideoOverlay>
      )}
      <StyledVideo
        videoSrcURL={video.embedURL}
        frame={video.html}
        playing={playing}
      />
    </Wrapper>
  );
}

VideoPlayer.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default VideoPlayer;
